import SectionHeading from '@atom/components/common/map/mapDrawerContent/SectionHeading';
import { Task } from '@atom/types/task';

import TaskRow from './TaskRow';

import classes from './workSummaryTray.module.css';

interface Props {
  tasks: Task[];
}

const WorkSummaryTasks = ({ tasks }: Props) => {
  return (
    <div className={classes.taskContainer}>
      <SectionHeading title={`${tasks.length} tasks`} />
      <div className={classes.taskDetailSection}>
        {tasks.map(task => (
          <TaskRow key={task.id} task={task} />
        ))}
      </div>
    </div>
  );
};

export default WorkSummaryTasks;
